// @ts-check

import React from "react";
import { BlockStack, Box, Card, Icon, InlineStack, Text, Tooltip } from "@shopify/polaris";
import { SparkLineChart } from "@shopify/polaris-viz";
import { InfoIcon } from "@shopify/polaris-icons";

export const StatBox = ({
  title,
  description,
  value,
  data = [],
  loading = false,
}) => {
  let formattedValue;
  if (loading) {
    formattedValue = "...";
  } else {
    formattedValue = value;
  }

  let helper;
  if (description) {
    helper = (
      <Tooltip content={description}>
        <Icon source={InfoIcon} tone="subdued" />
      </Tooltip>
    );
  }

  let chart;
  if (data?.length) {
    chart = (
      <div style={{ flex: 1, width: '50%', height: '80%', alignSelf: 'center' }}>
        <SparkLineChart
          offsetLeft={4}
          offsetRight={16}
          theme="Light"
          data={data}
        />
      </div>
    );
  }

  return (
    <Card padding="0">
      <InlineStack>
        <Box padding="400">
          <BlockStack>
            <InlineStack gap="200">
              <Text as="p" variant="bodyMd" tone="subdued">{title}</Text>
              {helper}
            </InlineStack>
            <Text as="p" variant="headingXl">{formattedValue}</Text>
          </BlockStack>
        </Box>

        {chart}
      </InlineStack>
    </Card>
  );
};
